export default "__VITE_ASSET__Cmc$VckZ__"